import { Button } from "components/Button/Button"
import { ErrorStatus } from "components/ErrorStatus/ErrorStatus"
import { Modal } from "components/Modal/Modal"
import { useAuth } from "modules/auth/Auth"
import { useState } from "react"
import { useLegalAccept, useLegalURLs, useUserRole } from "services/users"
import { cn } from "styles/cn"

export function LegalAgreement() {
	const { signOut } = useAuth()
	const { data: { isPatient, isProvider, legal } = {}, ...userRole } =
		useUserRole()
	const legalEnabled = isPatient || isProvider
	const { data: { termsOfUse, privacyPolicy } = {}, ...legalUrls } =
		useLegalURLs(legalEnabled)
	const { mutate, isError, isPending } = useLegalAccept()
	const [legalUrl, setLegalUrl] = useState<string>()

	if (userRole.isFetching || legalUrls.isFetching) {
		return null
	}

	if (userRole.isFetched && (!legalEnabled || legal)) {
		return null
	}

	return (
		<Modal
			open
			title="Terms of use & privacy policy"
			okText="Agree"
			cancelText="Disagree"
			cancelButtonProps={{ danger: true }}
			confirmLoading={isPending}
			onOk={() => mutate()}
			onCancel={async () => await signOut()}
			className={cn(legalUrl && "min-w-dvw")}
			classNames={{
				container: cn(legalUrl && "max-h-dvh min-h-dvh rounded-none"),
				body: cn("flex flex-col gap-2", legalUrl && "h-svh"),
			}}
		>
			<div className="flex flex-row items-center gap-0.5">
				Please, read and agree to the
				<Button
					type="link"
					className="h-fit p-0 pr-0.5"
					disabled={!termsOfUse}
					onClick={() => setLegalUrl(termsOfUse!)}
				>
					Terms of use
				</Button>
				&
				<Button
					type="link"
					disabled={!privacyPolicy}
					className="h-fit p-0 pl-0.5"
					onClick={() => setLegalUrl(privacyPolicy!)}
				>
					Privacy policy
				</Button>
			</div>

			<ErrorStatus show={isError}>
				An unexpected error occurred while saving your answer. Please, try
				again.
			</ErrorStatus>

			{legalUrl && (
				<iframe
					key={legalUrl}
					allow="fullscreen"
					title="Legal document"
					className="size-full w-full flex-1 border-0"
					src={legalUrl!}
				/>
			)}
		</Modal>
	)
}
